import React from 'react';
import { ButtonBase, ButtonBaseProps } from '@mui/material';

import { touchTargetSx } from 'theme/touchTarget';

type Props = ButtonBaseProps & { collapsed: boolean };

export const GroupToggle: React.FC<Props> = ({ collapsed, sx, ...props }) => (
  <ButtonBase
    disableRipple
    aria-expanded={!collapsed}
    {...props}
    sx={[
      {
        width: '100%',
        justifyContent: 'flex-start',
        textAlign: 'left',
        ...touchTargetSx,
        '&.Mui-focusVisible': {
          outline: '2px solid',
          outlineColor: 'text.link',
          outlineOffset: '-2px',
        },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);
